<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/enquate/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ enquate_sheet_obj }} -->
    <div
      class="w100"
      v-if="
        typeof enquate_sheet_list === 'object' &&
        Object.keys(enquate_sheet_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%">ID</th>
            <th style="width: auto">名称</th>
            <th style="width: 10%">設問数</th>
            <th style="width: 10%">ソート<br />No</th>
            <th colspan="2" style="width: 12%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in enquate_sheet_list" :key="list.id">
            <td>{{ list.id }}</td>
            <td>{{ list.label }}</td>
            <td>
              <span
                v-if="
                  typeof (list || {}).enquate_data === 'object' &&
                  (list || {}).enquate_data.length > 0
                "
              >
                {{ (list || {}).enquate_data.length }}問
              </span>
              <span v-else>0</span>
            </td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>
<style>
.btn_order {
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'
// import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'
// import moment from 'moment'

export default {
  name: 'EnquateListview',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'アンケートデータ一覧',
      fromParentBtn: 'データ登録',
      enquate_sheet_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsButton
    // BsSelect
  },
  computed: {
    ...mapState({}),
    enquate_sheet_list: function () {
      const tmps = [...this.enquate_sheet_obj]
      return tmps.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadEnquateSheetList()
  },
  mounted: function () {
    this.alertMessage = 'アンケートデータ一覧です。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.enquate_sheet_obj.find(sheet => {
          return sheet.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'enquate_sheet' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadEnquateSheetList()
          })
      }
    },
    async search_enquate() {
      this.page = 0
      await this.loadEnquateSheetList()
    },
    async loadEnquateSheetList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/enquate_sheet/lists',
        params
      )
        .then(async response => {
          console.log('loadEnquateSheetList', response)
          if (response.data.body) {
            this.enquate_sheet_obj = response.data.body
          } else {
            this.enquate_sheet_obj = []
          }
        })
        .catch(async err => {
          console.log(err)
          this.enquate_sheet_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/enquate/' + target + '/' })
    }
  }
}
</script>
